// REACT IMPORTS

// COMPONENT IMPORTS
import SidePanel from "components/auth/SidePanel";
import LoginViaCredForm from "components/auth/LoginViaCredForm";
import QuestionsFooter from "components/auth/QuestionsFooter";
import LoginForm from "components/auth/LoginForm";
import { accountDetailsGet, useAccountDetails } from "store/slices/authSlice";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "store/hooks";
import { useEffect, useState } from "react";
import Helment from "components/layout/helmet";
import { useIsLogin } from "store/slices/commonSlice";
import { decode } from "utils/HelperFunctions";
import { TestIdScope } from "utils/testid";

/* ------------------------------------- LOGIN VIA CRED PAGE ------------------------------------- */

const LoginViaCred = () => {
  const { clusterId: cluster_id } = useParams();
  const clusterId = decode(cluster_id || "", true);
  const dispatch = useAppDispatch();
  const accountDetails = useAccountDetails();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isLogin = useIsLogin();

  const onGetAccountDetails = async () => {
    try {
      let payload = {
        cluster_id: clusterId,
      };
      await dispatch(accountDetailsGet(payload)).unwrap();
    } catch (error: any) {
      console.log("get account details err: -->", error?.message);
    }
  };

  useEffect(() => {
    if (
      (!accountDetails || Object.keys(accountDetails).length === 0) &&
      !isLogin
    ) {
      onGetAccountDetails();
    } else setIsLoading(false);
  }, [accountDetails, isLogin]);

  return (
    <>
      <Helment />
      <TestIdScope scope="auth-password-login">
        <div
          data-testid="auth-password-login-page"
          className="portal-shell h-[var(--shell-vh)] flex lg:flex-row flex-col lg:justify-center lg:overflow-y-none overflow-y-auto relative animate__animated animate__fadeIn"
        >
          <div className="lg:w-2/5 w-full">
            <SidePanel />
          </div>
          {/* Same left-aligned desktop offset as the main login page. */}
          <div className="lg:w-3/5 flex flex-col justify-between h-full items-center lg:items-start lg:pl-[150px] lg:pr-0 lg:overflow-y-auto px-4 overflow-y-scroll">
            <div className="lg:pt-[88px] pt-4">
              {accountDetails?.data?.login_type === "EP" ||
              accountDetails?.data?.login_type === "BOTH" ? (
                <LoginViaCredForm />
              ) : accountDetails?.data?.login_type === "CD" ? (
                <LoginForm />
              ) : null}
            </div>
            {/* LoginForm renders its own QuestionsFooter, so only add one for the credential form */}
            {accountDetails?.data?.login_type !== "CD" && (
              <div className={`pb-5 lg:pt-0 pt-4 lg:w-full`}>
                <QuestionsFooter />
              </div>
            )}
          </div>
        </div>
      </TestIdScope>
    </>
  );
};

export default LoginViaCred;
